import { t } from "components/CentralDataMangement/translation/Translation";
import React from "react";
import { Spinner } from "react-bootstrap";
interface Props {
  headerLength?: number;
  isDiv?: boolean;
  message?: string; // Optional message prop for customization
  className?: string;
  centerClass?:string;
}
const SpinnerWrapper: React.FC<Props> = ({
  headerLength,
  isDiv = false,
  className,
  message = "Loading...",
  centerClass = "text-center"
}) => {
  return (
    <>
      {isDiv ? (
        <div className={`${centerClass} ${className}`}>
          <Spinner size="sm" className="me-2 spinnerIcon" />  {t(message)}
        </div>
      ) : (
        <tr>
          <td
            colSpan={headerLength}
            className="border text-center"
          >
            <Spinner size="sm" className="me-2 spinnerIcon" /> {t(message)}
          </td>
        </tr>
      )}
    </>
  );
};

export default SpinnerWrapper;
